import LazyLoad from "vanilla-lazyload";


const lazyLoader = new LazyLoad({
    elements_selector: ".lazy",
    data_src: 'lazy'
});

export default lazyLoader;